<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="table-action-box" v-bind="attrs" v-on="on">
        <v-icon small>mdi-pencil</v-icon>
        <span class="table-action-label">Editar</span>
      </div>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-view-column</v-icon>
        <div>
          <span class="sc-modal__title">Editar coluna</span>
          <span class="sc-modal__subtitle">Altere o nome ou status da coluna</span>
        </div>
      </div>

      <!-- Form -->
      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Nome da coluna</label>
          <v-text-field
            solo
            flat
            dense
            background-color="surface_tertiary"
            placeholder="Nome da coluna"
            v-model="dsc_coluna"
            hide-details="auto"
          />
        </div>
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Status</label>
          <div class="coluna-switch">
            <v-switch
              v-model="flg_ativo"
              :label="flg_ativo ? 'Ativa' : 'Inativa'"
              color="primary"
              hide-details
              dense
            />
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text @click="close" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click.prevent="atualizarColuna()"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          Atualizar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from '@/services/api';
import { mapActions } from 'vuex';

export default {
  name: "ModalEditarColuna",
  props: {
    item: Object,
    changeColuna: Function,
    num_coluna_telao: Number,
  },
  data() {
    return {
      loading: false,
      dsc_coluna: "",
      dialog: false,
      flg_ativo: false,
    };
  },
  watch: {
    dialog(open) {
      if (open) this.seedForm();
    },
  },
  created() {
    this.seedForm();
  },
  methods: {
    ...mapActions({
      getColunas: 'colaboracoes_moderadas/getColunas',
    }),
    seedForm() {
      if (this.item) {
        this.dsc_coluna = this.item.dsc_coluna;
        this.flg_ativo = this.item.flg_ativo;
      }
    },
    close() {
      this.dialog = false;
    },
    async atualizarColuna() {
      try {
        this.loading = true;

        if (this.dsc_coluna.trim() === "") {
          return this.$toast.error('O campo nome da coluna é obrigatório.');
        }

        const payload = {
          dsc_coluna: this.dsc_coluna,
          flg_ativo: this.flg_ativo,
          cod_producao: this.item.cod_producao,
          cod_coluna: this.item.cod_coluna,
        };

        const response = await apiClient.patch('/atualizarColuna', payload);

        if (response.status === 200) {
          this.$toast.success(response.data.msg);
          await this.getColunas({ cod_producao: this.$store.state.producoes.selectedProducao.cod_producao });
          const colunas_ativas = await this.getColunas({ cod_producao: this.$store.state.producoes.selectedProducao.cod_producao, flg_ativo: true });
          this.changeColuna(colunas_ativas[0].num_coluna_telao, colunas_ativas[0]);
          this.dialog = false;
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || 'Erro ao atualizar coluna.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.coluna-switch {
  padding: 8px 12px;
  background: var(--sc-surface-tint);
  border-radius: var(--sc-radius-md);

  ::v-deep .v-input--switch { margin: 0; padding: 0; }
}
</style>
